import { c as _c } from "react/compiler-runtime";
import React from 'react';
import loadable from '@loadable/component';
import BrowserOnly from 'components/consumer/BrowserOnly';
const CartModalUI = loadable(() => import('./CartModalUI'));
const CartModal = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <BrowserOnly><CartModalUI /></BrowserOnly>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default CartModal;